export const DIALOG_HEADER_CLASSNAME = 'joykit-dialog-header';
